import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import * as types from '@reserve/store/types'
import { mapGetters } from 'vuex'

import DayView from '@reserve/components/DayView/DayView.vue'
import MergeView from '@reserve/components/MergeView/MergeView.vue'
import reserveHelper from '@reserve/reserve-helper'

@Component({
    components: {
        DayView,
        MergeView
    },

    computed:  mapGetters({
        selectedResources: types.SELECTED_RESOURCE_LIST 
    })
})
export default class DayViewMaster  extends Vue {
    selectedResources!: reserve.ResourceItemBase[];

    currentView: any = DayView;        

    @Watch('selectedResources')
    onSelectedResourceChanged(newVal: reserve.ResourceItemBase[]) {
        let resrouces = newVal.filter(r => !reserveHelper.isHeaderType(r.resourceType));

        if(resrouces.length <= 1) {
            this.currentView = DayView;
        } else {
            this.currentView = MergeView;
        }
    }

    created() {
        this.onSelectedResourceChanged(this.selectedResources);
    }
}